// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\" viewBox=\"0 -1 10 10\"> <path data-name=\"Path 748\" d=\"m1.059 4.059 2.667 3 5.333-6\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"/> </svg> ";
// Exports
module.exports = code;